import Affiliate from './affiliate.service';
import Attribute from './attribute.service';
import Basket from './basket.service';
import Brand from './brand.service';
import Category from './category.service';
import CategoryGroup from './categoryGroup.service';
import Customer from './customer.service';
import Definition from './definition.service';
import Http from './http.service';
import Invoice from './invoice.service';
import Language from './language.service';
import Lodash from './lodash.service';
import Price from './price.service';
import Push from './push.service';
import Session from './session.service';
import Socket from './socket.service';
import User from './user.service';

const module = angular.module('app.services', [])
	.factory('_', Lodash)
	.service('Affiliate', Affiliate)
	.service('Attribute', Attribute)
	.service('Basket', Basket)
	.service('Brand', Brand)
	.service('Category', Category)
	.service('CategoryGroup', CategoryGroup)
	.service('Customer', Customer)
	.service('Definition', Definition)
	.service('Http', Http)
	.service('Invoice', Invoice)
	.service('Language', Language)
	.service('Price', Price)
	.service('Push', Push)
	.service('Session', Session)
	.service('Socket', Socket)
	.service('User', User)
	.name;

export default module;


// WEBPACK FOOTER //
// ./app/shared/services/services.js